import { useParams } from 'react-router-dom'
import { Image } from 'react-bootstrap'
import { Flex } from 'antd'
import useLang from '@/utils/hooks/use-lang'
import PageWrapper from '@/components/page-wrapper'
import { i18nSolution, type SolutionProps } from '@/assets/content/solution'
import Banner from './items/banner'
import AnchorPoint from './items/anchor-point'
import Advantage from './items/advantage'
import Application from './items/application'
import Product from './items/product'
import SuccessCases from './items/case'
import MedicalSolution from './medical-solution'
import GreenCity from './green-city'
import GreenPowerPlant from './green-power-plant'
import RenewableEnergy from './renewable-energy'
import Styles from './style.module.scss'

const pathCompMaps = {
  'medical-solution': <MedicalSolution />,
  'green-city': <GreenCity />,
  'green-power-plant': <GreenPowerPlant />,
  'renewable-energy': <RenewableEnergy />,
}

export default function Index() {
  const { type } = useParams()
  const [lang] = useLang()
  const content: SolutionProps = i18nSolution?.[lang].find(({ path }) => path === `/solution/${type}`)

  if (!content) {
    return pathCompMaps?.[type] || <div>404</div>
  }

  const { title, banner, solution, advantage, application, product, success_case } = content || {}

  return (
    <PageWrapper soul mainStyle={{ backgroundColor: '#fff' }}>
      <Banner banner={banner} title={title} />
      <AnchorPoint attrs={Object.keys(content)} />
      <Flex vertical className={Styles.solutionWrapper} id='solution'>
        {solution?.map(imgUrl => (
          <Image key={imgUrl} src={imgUrl} style={{ width: '100%' }} />
        ))}
      </Flex>
      <Advantage data={advantage} />
      <Application data={application} />
      <Product data={product} />
      <SuccessCases data={success_case} />
    </PageWrapper>
  )
}
